import { ArrowDownUp } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router-dom";

interface ColumnsProps {
  columnName: (data: any) => void;
  onClickDelete: (data: any) => void;
}

const Pament2Column = ({ columnName, onClickDelete }: ColumnsProps) => {
  const Pament2Column = useMemo(
    () => [
      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("price")}
          >
            <span>مبلغ</span>
            <span className="text-blue-600 rtl text-[10px]">(ریال)</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "price",
        cell: (cell: any) => {
          const value = cell.getValue();

          return (
            <div className="text-center rtl">
              <span
                className={`inline-block  ${value < 0 ? "text-red-600 font-bold" : ""
                  }`}
                dir="ltr"
              >
                {value.toLocaleString()}
              </span>
            </div>

          );
        },
      }
      ,
      {
        header: "کشاورز",
        accessorKey: "farmer_name",
        cell: (cell: any) => <div>{cell.getValue() || "نامشخص"}</div>,
      },
      {
        header: () => (
          <div
            className="flex items-center gap-1"
            onClick={() => columnName("payment_reason_name")}
          >
            <span>نوع پرداخت</span>
            <ArrowDownUp className="text-blue-800" size={16} />
          </div>
        ),
        accessorKey: "payment_reason_name",
        cell: (cell: any) => <div>{cell.getValue() || "نامشخص"}</div>,
      },
      {
        header: "تاریخ ثبت",
        accessorKey: "created_at",
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link
              to="#!"
              className="flex items-center mr-4 justify-center size-8 transition-all duration-200 ease-linear rounded-md remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
              onClick={() => {
                const data = cell.row.original;
                onClickDelete(data);
              }}
            >
              <span className="rounded p-1 w-20 ml-3 bg-red-800 text-white">
                حذف
              </span>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return Pament2Column;
};

export default Pament2Column;
